export { DefaultTemplate, type DefaultTemplateProps } from '../templates/Default/index.js'
export { MinimalTemplate, type MinimalTemplateProps } from '../templates/Minimal/index.js'
